import React, { Component } from 'react';
import { Chart } from 'primereact/chart';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Buscar, vendasStatus ,  vendedorVendas } from '../../services/contratos';

import Organograma from '../organograma';
import { buscaHieraquia } from '../../services/hierarquia';
import { Card } from 'primereact/card';
import fundo_amarelo from '../../assets/fundo_amarelo.png';
import { ProgressSpinner } from 'primereact/progressspinner';
import { CalculoComissao } from '../../services/comissoes/index';
import api from '../../services/backAxios/index';
import InputMask from 'react-input-mask';
import * as moment from 'moment';
import { decriptObjectOnLocalStorage, decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';

let areaColaborador;
const nome = '';
const meses = [
    '',
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro'
];
export default class graficoCompras extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cod: '',
            nome: decriptoLocalStorage('Nome')?.decriptoValue,
            dados: [],
            dadi: [],
            teste: '',
            totalRecebidos: '',
            totalEntregues: '',
            loading: 'loading',
            submit: '',
            token: '',
            displayBasic: false,
            hierarquia: false,
            permissao: '',
            comissao: '',
            dataMes: '',
            dataAno: ''
        };
        this.codigo = decriptoLocalStorage('codigo_vendedor')?.decriptoValue;
        this.onClick = this.onClick.bind(this);
        this.onHide = this.onHide.bind(this);
    }

    onClick(name, position) {
        let state = {
            [`${name}`]: true
        };

        if (position) {
            state = {
                ...state,
                position
            };
        }

        this.setState(state);
    }

    state = {
        cod: '',
        nome: decriptoLocalStorage('Nome')?.decriptoValue,
        dados: [],
        dadi: [],
        teste: '',
        totalRecebidos: '',
        totalEntregues: '',
        loading: 'loading',
        submit: '',
        token: '',
        permissao: decriptObjectOnLocalStorage('PERM')
    };

    onHide(name) {
        this.setState({
            [`${name}`]: false
        });
    }

    async componentDidMount() {
        const area = decriptoLocalStorage('area');

        switch (area) {
        case '1':
            areaColaborador = 'EXTERNO';
            break;
        case '2':
            areaColaborador = 'TELEMARKETING';
            break;
        case '3':
            areaColaborador = 'PRIME';
            break;
        case '4':
            areaColaborador = 'PDV';
            break;
        case '5':
            areaColaborador = 'TERCEIRIZADO';
            break;
        default:
            areaColaborador = 'PRIME';
        }

        this.permissao = decriptoLocalStorage('PERM')?.decriptoValue;

        let route;

        switch (this.permissao) {
        case '3':
            this.setState({ permissao: '/supervisor' });
            route = 'supervisor';
            break;
        case '2':
            this.setState({ permissao: '/coordenador' });
            route = 'coordenador';
            break;
        default:
            this.setState({ permissao: '/vendedor' });
            route = 'vendedor';
            break;
        }

        this.setState({ loading: 'nada',
            submit: true });
        this.setState({ cod: decriptoLocalStorage('codigo_vendedor')?.decriptoValue });

        this.setState({ loading: 'nada',
            submit: true });
        this.busca(this.codigo);
    }

    somaComicao1 = async () => {
        const dados = {
            Codigo: this.codigo,
            data_inicio: moment().format('YYYY-MM-01'),
            data_fim: moment().format('YYYY-MM-DD'),
            area: areaColaborador
        };

        await CalculoComissao('vendedor', dados)
            .then(resp=>{
                this.setState({ comissao: resp });
            }).catch (error => {
                console.err(error);
            });
    };

    busca = async codigo => {
        this.somaComicao1();
        await Buscar(codigo, decriptObjectOnLocalStorage('PERM'))
            .then(response => {
                this.entregues();
                this.buscaTabela(codigo);
            })
            .catch(function (erro) {
                this.entregues();
                this.setState({ loading: 'loading',
                    submit: true });
            });
    };

    atualizarGraficos = () => {
        window.location.reload();
    };

    entregues = async () => {
        // await BuscarEntregues(codigo)
        //     .then(result => {
        //this.setState({ totalEntregues: result })
        this.buscaVend(this.codigo);

        // }).catch(function (erro) {
        //     this.buscaVend(codigo);
        //     this.setState({ loading: 'loading', submit: true });
        // });
    };

    buscaVend = async codigo => {
        await vendedorVendas(codigo)
            .then(resp => {
                this.setState({ dados: resp });
                setTimeout(() => {
                    this.setState({ loading: 'loading',
                        submit: false });
                }, 1000);
            })
            .catch(err => {
                this.busca(this.state.cod);
            });

        await vendasStatus(codigo)
            .then(res => {
                this.setState({ dadi: res?.data });

                if (res?.data?.length > 0) {
                    for (let i = 0; i < res?.data?.length; i++) {
                        if (res.data[i].Status) {
                            if (res.data[i].Status === 1) {
                                res.data[i].Status = 'Ativo';
                            }

                            if (res.data[i].Status === 2) {
                                res.data[i].Status = 'Suspenso';
                            }

                            if (res.data[i].Status === 3) {
                                res.data[i].Status = 'Cancelado';
                            }

                            if (res.data[i].Status === 4) {
                                res.data[i].Status = 'Em Carencia';
                            }

                            if (res.data[i].Status === 5) {
                                res.data[i].Status = 'Aguardando';
                            }

                            if (res.data[i].Status === 6) {
                                res.data[i].Status = 'Não Confirmado';
                            }
                        }
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
    };

    buscaTabela = async codigo => {
        await buscaHieraquia(this.state.permissao, { Codigo: codigo })
            .then(result => {
                this.setState({ hierarquia: result });
            })
            .catch(error => {
                console.error(error);
                alert('Error ao carregar os dados!');
            });
    };

    updatedField(event) {
        const enviarBody = event.target.value;
        const mes = enviarBody.substring(0, enviarBody.search('/'));
        const ano = enviarBody.substring(enviarBody.search('/') + 1);

        this.setState({ dataMes: parseInt(mes) });
        this.setState({ dataAno: parseInt(ano) });
    }

    save() {
        const body = {
            dataMes: this.state.dataMes,
            dataAno: this.state.dataAno
        };

        api.post(`/associados-vendedor/vendasTotal/${this.codigo}`, body)
            .then(resp => {
                this.setState({ dados: resp.data });
            })
            .catch(err => {
                this.busca(this.state.cod);
            });
    }

    render() {
        const regra = this.state.dados;
        let dados;
        const nomes = [];
        let metas = [];
        let total = areaColaborador == 'PRIME' ? 12 : 26;
        const num = total;

        Array.isArray(regra) && regra.forEach((value, i) => {
            dados = value.Mes;
            value.Nome = meses[dados];
            nomes[i] = value.Nome;
        });

        const mes = Array.isArray(regra) && regra.map(values => values.Total);

        if (nomes.length === 4) {
            metas = [26, 26, 26, 26];
        }

        if (nomes.length === 3) {
            metas = [26, 26, 26];
        }

        if (nomes[2]) {
            total = total - mes[2];

            if (total < mes[2]) {
                total = 0;
            }
        }

        const data = {
            labels: nomes,
            datasets: [
                {
                    label: 'Vendas Aprovadas',
                    backgroundColor: '#F4C27A',
                    data: mes
                },
                {
                    label: 'Metas de Venda',
                    backgroundColor: '#27348B',
                    data: [num, num, num, num, num]
                }
            ]
        };

        const options = {
            title: {
                display: true,
                text: 'Venda nos ultimos meses',
                fontSize: 15
            },
            legend: {
                position: 'bottom',
                width: 1
            },
            barPercentage: 0.5,
            barThickness: 6,
            maxBarThickness: 8,
            minBarLength: 2,
            scales: {
                xAxes: [
                    {
                        stacked: false
                    }
                ],
                yAxes: [
                    {
                        stacked: false
                    }
                ]
            }
        };

        const a = Array.isArray(this.state.dados) && this.state.dados.map(values => values.Total);

        let vendasTotal;

        if (a === undefined) {
            vendasTotal = 0;
        }

        if (a[2]) {
            vendasTotal = a[2];
        }

        if (a[3]) {
            vendasTotal = a[3];
        }

        if (a[2] === null || a[2] === undefined) {
            vendasTotal = a[0];
        }

        if (a.length === 0) {
            vendasTotal = 0;
        }

        const options2 = {
            title: {
                display: true,
                text: `Total de Vendas : ${vendasTotal? vendasTotal : 0}`,
                fontSize: 15
            },
            legend: {
                position: 'bottom',
                width: 1
            },
            cutoutPercentage: 50,
            circumference: Math.PI,
            rotation: Math.PI
        };

        const total2 = total - vendasTotal;
        const data2 = {
            labels: ['Total de vendas', 'Metas Restantes'],
            datasets: [
                {
                    data: [vendasTotal, total2],
                    backgroundColor: ['#96C929']
                }
            ]
        };

        const vendasStatusNome = Array.isArray(this.state.dadi) && this.state.dadi.map(value => value.Status);
        const vendaStatusTotal = Array.isArray(this.state.dadi) && this.state.dadi.map(value => value.Total);

        const data3 = {
            labels: vendasStatusNome,
            datasets: [
                {
                    label: 'Total de vendas',
                    backgroundColor: '#27348B',
                    data: vendaStatusTotal
                }
            ]
        };

        const options3 = {
            title: {
                display: true,
                text: 'Vendas por Status',
                fontSize: 15
            },
            legend: {
                position: 'bottom',
                width: 1
            },
            barPercentage: 0.5,
            barThickness: 6,
            maxBarThickness: 8,
            minBarLength: 2,
            scales: {
                xAxes: [
                    {
                        stacked: false
                    }
                ],
                yAxes: [
                    {
                        stacked: false
                    }
                ]
            }
        };
        const header = <img alt="Card" src={fundo_amarelo} />;

        return (
            <>
                <div className={this.state.loading}>
                    <ProgressSpinner
                        className='isLoading'
                        strokeWidth="1"
                        fill="#EEEEEE"
                        animationDuration=".5s"
                    />
                </div>
                {this.state.submit !== true ? (
                    <Card className='tratar-scroll-card' header={header} title="Home">
                        <div className="p-col-12 p-md-6 p-lg-6">
                            <label style={{ width: '100' }}>
                                <h3
                                    style={{
                                        color: 'black',
                                        marginBottom: '1%'
                                    }}
                                >
                                    Filtrar data dos gráficos:
                                </h3>
                                <InputMask
                                    mask="99/9999"
                                    maskChar={null}
                                    style={{ height: '29px' }}
                                    type="text"
                                    onChange={e => this.updatedField(e)}
                                />{' '}
                                <a /> <a />
                                <Button
                                    label="Filtrar"
                                    onClick={() => this.save()}
                                />
                            </label>
                        </div>
                        <div className="group">
                            <br />
                            <div className="p-grid">
                                <br />
                                <br />
                                <div className="p-col-12 p-md-6 p-lg-3">
                                    <Card className="ui-card-shadow ">
                                        <div>
                                            <a
                                                href="/meus-dados"
                                                style={{ color: 'black',
                                                    fontSize: '15px' }}
                                                // style={{
                                                //     color: 'gray',
                                                // }}
                                                className="p-col-12 p-md-12 p-lg-12"
                                            >
                                                <i
                                                    className="pi pi-user"
                                                    style={{ color: '#27348B' }}
                                                ></i>
                                                {this.state.nome}
                                            </a>
                                        </div>
                                    </Card>
                                </div>
                                {/* eslint-disable-next-line no-constant-condition */}
                                {1 == 1 ? (
                                    <div className="p-col-12 p-md-6 p-lg-3">
                                        <Card className="ui-card-shadow ">
                                            <div>
                                                {/**descomentar link quando homologar relatórios */}
                                                {/*<Link to='/relatorio'>*/}
                                                <a
                                                    style={{ color: 'black',
                                                        fontSize: '15px' }}
                                                    // style={{
                                                    //     color: 'gray',

                                                    // }}
                                                    className="p-col-12 p-md-12 p-lg-12"
                                                >
                                                    <i
                                                        className="pi pi-money-bill"
                                                        style={{
                                                            color: '#27348B'
                                                        }}
                                                    ></i>
                                                    Comissão:{' '}
                                                </a>
                                                {/*</Link>*/}
                                            </div>
                                        </Card>
                                    </div>
                                ) : (
                                    ''
                                )}
                                <div className="p-col-12 p-md-6 p-lg-3">
                                    <Card className="ui-card-shadow ">
                                        <div>
                                            <a
                                                href="/contratos-recebidos"
                                                style={{ color: 'black',
                                                    fontSize: '15px' }}
                                                // style={{
                                                //     color: 'gray',

                                                // }}
                                                className="p-col-12 p-md-12 p-lg-12"
                                            >
                                                <i
                                                    className="pi pi-user"
                                                    style={{ color: '#96C929' }}
                                                ></i>
                                                Total de contratos Recebidos:{' '}
                                                {
                                                    this.state.totalRecebidos
                                                        .length
                                                }
                                            </a>
                                        </div>
                                    </Card>
                                </div>

                                {/* <div className="p-col-12 p-md-6 p-lg-3">
                                    <Card className="ui-card-shadow " >
                                        <div>
                                            <a href="/contratos-entregues" style={{ color: 'black' }}
                                                style={{ color: 'gray', fontSize: '15px' }}
                                                className="p-col-12 p-md-12 p-lg-12">
                                                <i className="pi pi-user" style={{ color: '#27348B' }}
                                                ></i>
                                Total de contratos Entregues: {this.state.totalEntregues.length}
                                            </a>
                                        </div>
                                    </Card>
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-3">
                                    <Card className="ui-card-shadow " >
                                        <div>
                                            <a href="/lista-contratos" style={{ color: 'black' }}
                                                style={{ color: 'gray', fontSize: '15px' }}
                                                className="p-col-12 p-md-12 p-lg-12">
                                                <i className="pi pi-user" style={{ color: '#96C929' }}
                                                ></i>
                                                Total de Contratos Aprovados: {mes[2]}
                                            </a>
                                        </div>
                                    </Card>
                                </div> */}
                            </div>
                            <br />
                            <Button
                                label="Atualizar gráficos"
                                style={{
                                    backgroundColor: '#E1E1E1',
                                    borderColor: 'gray',
                                    color: 'gray'
                                }}
                                onClick={() => this.atualizarGraficos()}
                            />{' '}
                            <a /> <a />
                            <Button
                                label="Abrir Hierarquia"
                                onClick={() => this.onClick('displayBasic')}
                            />
                            <Dialog
                                header="Hierarquia"
                                visible={this.state.displayBasic}
                                style={{ width: '75vw' }}
                                maximizable
                                onHide={() => this.onHide('displayBasic')}
                            >
                                <Organograma
                                    dadosHierarquia={this.state.hierarquia}
                                />
                            </Dialog>
                            <div className="p-grid p-fluid">
                                <div className="p-col-12 p-md-6 p-lg-6 p-sm-6">
                                    <Chart
                                        type="bar"
                                        data={data}
                                        options={options}
                                    />
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-6 p-sm-6">
                                    <Chart
                                        type="doughnut"
                                        options={options2}
                                        data={data2}
                                    />
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-6 p-sm-6">
                                    <Chart
                                        type="bar"
                                        data={data3}
                                        options={options3}
                                    />
                                </div>
                            </div>
                            <br />
                        </div>
                    </Card>
                ) : null}
            </>
        );
    }
}
